import { IPayload } from '../../models/Global'
import { IGetStrikesParams, IStrike } from '../../models/Strike'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'

export class StrikesApi {
  constructor(private axios: AxiosService) {}

  getStrikes = async (params?: IGetStrikesParams) => {
    const response = await this.axios.get<IPayload<IStrike[]>>(
      Endpoints.getStrikes,
      params,
    )
    return response
  }
}
